
import Swal from "sweetalert2";
import React, { useEffect, useState } from "react";
import { EyeEmpty, EyeOff } from "iconoir-react";
import {
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
} from "@material-ui/core";
import { domain } from "../../../Urls/Services/Api_urls";
import Logonew from "../../../assets/LogoNew.webp";

export default function Recontra() {
  const [password, setPasswords] = useState("");
  const [password2, setPasswords2] = useState("");
  const [verification_code, setverification_code] = useState("");

  const url = domain + "/user/change/password/";
  const url1 = domain + "/user/change/password/verification_code/";
  // const url2 = domain + "/user/" + token + "/UnifiedSaleUser/";

  const [showPassword, setShowPassword] = React.useState(false);
  const [showPassword1, setShowPassword1] = React.useState(false);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const type = params.type;
  // const token = params.token;

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const Cambiocon = () => {
    if (password === password2) {
      const credentials = { verification_code, password };
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credentials),
      }).then(async function (response) {
        if (response.status === 200) {
          Swal.fire({
            title: "Perfecto!",
            text: "Se cambio la contraseña exitosamente",
            icon: "success",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            window.location.href = "/Login";
          });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Ingresa el código que llego a tu correo ",
            text: "Revisa tus contraseñas!",
          });
          Swal.fire({
            // toast: true,
            title: "Ingresa el código que llego a tu correo",
            input: "text",
            inputAttributes: {
              autocapitalize: "off",
            },

            confirmButtonText: "Verificar",
            showLoaderOnConfirm: true,
            preConfirm: (code) => {
              console.log({ verification_code: code });

              return fetch(url1, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ verification_code: code }),
              })
                .then(async function (response) {
                  if (response.status === 200) {
                    setverification_code(code);
                    Swal.fire({
                      icon: "success",
                      title: "Codigo correcto",
                      showConfirmButton: false,
                      timer: 1200,
                    });
                  } else {
                    Swal.showValidationMessage(`Error en el codigo`);
                  }
                })
                .catch((error) => {
                  Swal.showValidationMessage(`Request failed: ${error}`);
                });
            },
            allowOutsideClick: () => !Swal.isLoading(),
          });
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Las contraseñas no son iguales",
        text: "Revisa tus contraseñas!",
      });
    }
  };

  // const Cambioconunify = () => {
  //   if (password === password2) {
  //     const credentials = { password, password2 };
  //     fetch(url, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(credentials),
  //     }).then(async function (response) {
  //       if (response.status === 200) {
  //         Swal.fire({
  //           title: "Perfecto!",
  //           text: "Se cambio la contraseña exitosamente",
  //           icon: "success",
  //           showConfirmButton: false,
  //           timer: 3000,
  //         }).then(() => {
  //           window.location.href = "/Login";
  //         });
  //       } else if (response.status === 400) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Ingresa el código que llego a tu correo ",
  //           text: "Revisa tus contraseñas!",
  //         });
  //         Swal.fire({
  //           // toast: true,
  //           title: "",
  //           input: "text",
  //           inputAttributes: {
  //             autocapitalize: "off",
  //           },

  //           confirmButtonText: "Verificar",
  //           showLoaderOnConfirm: true,
  //           preConfirm: (code) => {
  //             return fetch(url1, {
  //               method: "POST",
  //               headers: { "Content-Type": "application/json" },
  //               body: JSON.stringify({ verification_code: code }),
  //             })
  //               .then(async function (response) {
  //                 if (response.status === 200) {
  //                   setverification_code(code);
  //                   Swal.fire({
  //                     icon: "success",
  //                     title: "Codigo correcto",
  //                     showConfirmButton: false,
  //                     timer: 1200,
  //                   });
  //                 } else {
  //                   Swal.showValidationMessage(`Error en el codigo`);
  //                 }
  //               })
  //               .catch((error) => {
  //                 Swal.showValidationMessage(`Request failed: ${error}`);
  //               });
  //           },
  //           allowOutsideClick: () => !Swal.isLoading(),
  //         });
  //       }
  //     });
  //   } else {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Las contraseñas no son iguales",
  //       text: "Revisa tus contraseñas!",
  //     });
  //   }
  // };

  const getToken = () => {
    Swal.fire({
      // toast: true,
      title: "Ingresa el código que llego a tu correo",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },

      confirmButtonText: "Verificar",
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        return fetch(url1, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ verification_code: login }),
        })
          .then(async function (response) {
            if (response.status === 200) {
              setverification_code(login);
              Swal.fire({
                icon: "success",
                title: "Codigo correcto",
                showConfirmButton: false,
                timer: 1200,
              });
            } else {
              Swal.showValidationMessage(`Error en el codigo`);
            }
          })
          .catch((error) => {
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
      allowOutsideClick: false,
    });
  };

  useEffect(() => {
    if (type !== "unifiedSale") {
      getToken();
    }
  }, []);

  return (
    <div>
      <body>
        <section className="derecha">
          <div className="shadow-md backdrop-blur-sm rounded-3xl bg-white/70 flex flex-col justify-center items-center p-2 ...  ">
            <a href="/" className="flex items-start  my-8 ">
            <img className="w-52" src={Logonew} alt="" />
            </a>
            <div style={{ height: 20 }} />
            <form>
              <div style={{ height: 20 }} />
              <FormControl>
                <InputLabel htmlFor="standard-adornment-password">
                  Contraseña*
                </InputLabel>

                <Input
                  id="standard-adornment-password"
                  type={showPassword ? "text" : "password"}
                  name="Nueva Contraseña"
                  required
                  variant="standard"
                  value={password2}
                  onChange={(e) => setPasswords2(e.target.value)}
                  style={{ width: "18rem" }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <EyeOff /> : <EyeEmpty />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>

              <div style={{ height: 20 }} />
              <FormControl>
                <InputLabel htmlFor="standard-adornment-password">
                  Confirmar Contraseña*
                </InputLabel>

                <Input
                  type={showPassword1 ? "text" : "password"}
                  name="Confirmar Contraseña"
                  onChange={(e) => setPasswords(e.target.value)}
                  required
                  value={password}
                  variant="standard"
                  style={{ width: "18rem" }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword1}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword1 ? <EyeOff /> : <EyeEmpty />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>

              <div style={{ height: 20 }} />

              <button
                className="w-[60%] mt-3 text-white rounded-xl bg-blue-500 hover:bg-blue-600 active:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300 ..."
                onClick={Cambiocon}
                type="button"
              >
                Confirmar
              </button>
            </form>
          </div>
        </section>
      </body>
    </div>
  );
}
